import { makeStyles, colors } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  claimPaper: {
    padding: theme.spacing(2),
    borderLeftWidth: 3,
    borderLeftStyle: 'solid',
  },
  claimPaperAdmissible: {
    borderLeftColor: theme.palette.success.main,
  },
  claimPaperGroundless: {
    borderLeftColor: theme.palette.error.main,
  },
  claimHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    cursor: 'pointer',
  },
  headerMain: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 0,
  },
  headerTopRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  claimType: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  excerptCollapsed: {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    fontStyle: 'italic',
    lineHeight: 1.4,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    margin: 0,
  },
  statusGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    flexWrap: 'wrap',
  },
  expandIcon: {
    color: theme.palette.text.secondary,
    transition: 'transform 0.2s ease',
  },
  expandIconOpen: {
    transform: 'rotate(180deg)',
  },
  statusChipAdmissible: {
    backgroundColor: colors.green[50],
    color: colors.green[800],
    fontWeight: 600,
    fontSize: '0.7rem',
    height: 22,
    '& .MuiChip-icon': {
      color: colors.green[700],
      marginLeft: 6,
    },
  },
  statusChipGroundless: {
    backgroundColor: colors.red[50],
    color: colors.red[800],
    fontWeight: 600,
    fontSize: '0.7rem',
    height: 22,
    '& .MuiChip-icon': {
      color: colors.red[700],
      marginLeft: 6,
    },
  },
  strengthChip: {
    fontSize: '0.7rem',
    height: 22,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
  },
  fallbackBadge: {
    fontSize: '0.7rem',
    height: 22,
    backgroundColor: colors.amber[50],
    color: colors.amber[900],
    fontWeight: 600,
  },
  expandedBody: {
    marginTop: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    borderTop: `1px dashed ${theme.palette.divider}`,
  },
  fieldLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(1.25),
  },
  excerpt: {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    fontStyle: 'italic',
    lineHeight: 1.55,
    paddingLeft: theme.spacing(1.25),
    borderLeft: `2px solid ${theme.palette.divider}`,
  },
  thesis: {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    lineHeight: 1.55,
  },
  evidencesRow: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
}))

export default useStyles
